<template>
<div class="login-a">
    <div class="login-container">
        <Row class="wd" type="flex" justify="space-between">
            <i-col span="12">
                <Row type="flex"
                    align="middle" class="play-area">
                    <i-col span="8">
                        <svg-icon class="hover-img"
                                    icon-class="play"></svg-icon>
                        <p class="item-title">组队闯关</p>
                    </i-col>
                    <i-col span="8">
                        <img class="hover-img"
                                src="@/assets/home/world.png"
                                alt />
                        <p class="item-title">我的世界</p>
                    </i-col>
                    <i-col span="8">
                        <svg-icon class="hover-img"
                                    icon-class="tools"></svg-icon>
                        <p class="item-title">控制玩具</p>
                    </i-col>
                    <i-col span="8">
                        <img class="hover-img"
                            src="@/assets/home/games.png"
                            alt />
                        <p class="item-title">创作游戏</p>
                    </i-col>
                    <i-col span="8">
                        <svg-icon class="hover-img"
                                icon-class="app"></svg-icon>
                        <p class="item-title">创作App</p>
                    </i-col>
                    <i-col span="8">
                        <svg-icon class="hover-img"
                                icon-class="web"></svg-icon>
                        <p class="item-title">搭建网站</p>
                    </i-col>
                </Row>
            </i-col>
            <i-col span="10">
                <login @closemodal="closeModal"></login>
            </i-col>
        </Row>
    </div>
  </div>
</template>
<script>
import login from "@/components/common/login.vue";
export default {
    components: {
        login
    },
    methods: {
        closeModal() {

        }
    }
}
</script>
<style lang="scss" scoped>
.login-a {
    background: rgba(106, 142, 217, 1) no-repeat 0 0;
    background-size: 100% 60px;
    margin-top: -70px;
    padding-top: 70px;
    .login-container{
        background: #fff;
        padding: 70px 0;
        .play-area{
            .hover-img {
                margin-top: 40px;
                font-size: 128px;
                margin-right: 10px;
                transition: all 0.2s ease-out;
                &:hover {
                    transform: scale(1.1);
                }
            }
            .item-title {
                color: #333;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px;
            }
        }
        .login{
            height: 392px;
            width: 410px;
            padding: 30px 15px;
            box-shadow: 0px 0px 10px rgba(204, 204, 204, 0.5);
        }
    }
    
}
</style>



// WEBPACK FOOTER //
// src/views/home/login.vue